/**
 * FavoritesModal - Extracted from App.js Phase 4
 * Browse and quick-log saved favorite meals
 */
import React from 'react';

const FavoritesModal = ({
  isOpen,
  onClose,
  favorites,
  logFavorite,
  removeFavorite
}) => {
  if (!isOpen) return null;

  // Sort favorites alphabetically by name
  const sortedFavorites = [...favorites].sort((a, b) => {
    const nameA = (a.name || a.food_items || '').toLowerCase();
    const nameB = (b.name || b.food_items || '').toLowerCase();
    return nameA.localeCompare(nameB);
  });

  return (
    <div className="modal-overlay" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '500px', maxHeight: '80vh', overflow: 'auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <h2 className="heading-3" style={{ margin: 0 }}>All Favorites ({favorites.length})</h2>
          <button onClick={onClose}
            style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: 'var(--text-secondary)' }}>x</button>
        </div>
        <p style={{ color: 'var(--text-secondary)', fontSize: '13px', marginBottom: '16px' }}>
          Quick log your favorite meals with one tap (sorted A-Z)
        </p>
        
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          {sortedFavorites.map((fav, index) => (
            <div key={fav.favorite_id || index}
              style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px',
                background: 'rgba(255,255,255,0.03)', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.08)' }}>
              <div style={{ flex: 1, minWidth: 0, marginRight: '12px' }}>
                <p style={{ margin: 0, fontSize: '14px', fontWeight: '500', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {fav.name || fav.food_items?.substring(0, 40)}
                </p>
                <p style={{ margin: '4px 0 0 0', fontSize: '12px', color: 'var(--text-secondary)' }}>
                  {fav.calories} kcal - P: {fav.protein}g - C: {fav.carbs}g - F: {fav.fat}g
                </p>
              </div>
              <div style={{ display: 'flex', gap: '8px' }}>
                <button data-testid={`fav-log-${index}`} onClick={() => { logFavorite(fav); onClose(); }}
                  style={{ padding: '8px 16px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    border: 'none', borderRadius: '6px', color: 'white', fontSize: '12px', fontWeight: '600', cursor: 'pointer' }}>
                  Log
                </button>
                <button data-testid={`fav-remove-${index}`} onClick={() => removeFavorite(fav.favorite_id)}
                  style={{ padding: '8px 12px', background: 'rgba(239, 68, 68, 0.1)', border: '1px solid rgba(239, 68, 68, 0.3)',
                    borderRadius: '6px', color: '#ef4444', fontSize: '12px', cursor: 'pointer' }}
                  title="Remove from favorites">
                  x
                </button>
              </div>
            </div>
          ))}
        </div>
        
        {favorites.length === 0 && (
          <div style={{ textAlign: 'center', padding: '32px', color: 'var(--text-secondary)' }}>
            <p style={{ fontSize: '32px', marginBottom: '12px' }}>star</p>
            <p>No favorites yet</p>
            <p style={{ fontSize: '12px' }}>Add meals to favorites from your logged meals</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default FavoritesModal;
